"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createFixedRateSampler = void 0;
var CryptoJS = _interopRequireWildcard(require("crypto-js"));
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
/**
 * Hashes a telemetry ID and maps it to a value between 0 and 1.
 *
 * @param id - The telemetry ID to hash.
 * @returns A number between 0 and 1 based on the hash value.
 */ var hashTelemetryId = function(id) {
    var hash = CryptoJS.SHA256(id).toString(CryptoJS.enc.Hex);
    return Number.parseInt(hash.slice(0, 8), 16) / 0xffffffff;
};
/**
 * Creates a fixed-rate sampler function to determine if telemetry should be kept
 * based on a hash of its ID and a specified sampling rate.
 *
 * @param samplingRate - Sampling rate as a percentage (e.g., 10 for 10%, 1 for 1%).
 * @returns A sampler function that takes an optional telemetry ID and returns `true` if the telemetry is kept, `false` otherwise.
 */ var createFixedRateSampler = function(percentage) {
    // Convert percentage to a decimal sampling rate
    var samplingRate = percentage / 100;
    /**
   * Sampler function to decide whether to include telemetry based on its ID.
   *
   * @param id - The telemetry ID (e.g., operation ID or custom data ID). If `undefined`, a random fallback is used.
   * @returns `true` if the telemetry should be kept, `false` otherwise.
   */ return function(id) {
        if (!id) {
            return Math.random() < samplingRate; // Fallback for missing IDs
        }
        var hashValue = hashTelemetryId(id);
        return hashValue < samplingRate; // Include if hash value is within the sampling rate
    };
};
exports.createFixedRateSampler = createFixedRateSampler; //# sourceMappingURL=createFixedRateSampler.js.map
